import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, ValidationMessage, ValidationMessageType, AppClientConfigurationService, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { ResponseStatus } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { BarcodeScan } from '@sdbn/tmc-common';
import { TerminalVisitorRegistration } from '../widgets/terminal/visitor-registration.model';
import { TerminalVisitorRegistrationResult } from '../tmc-visit.model';

export class VisitorRegistrationWithCodeQRCodeCombinedController extends AbstractStepController {

  private dialogService: DialogService;
  private configurationService: AppClientConfigurationService;
  private appServerAPI: AppServerAPI;

  // ProzessMapping basierend auf QRCode protocol/prefix
  private barcodeMappings = {};
  //
  private nextProcessStepRegistrationCode;
  // Definiert, ob RegistrationCodes in der Yardinstanz existieren müssen.
  private allowUnknownOnlineTerminalRegistrationCodes = false;
  // Definiert das maximale Alter von Onlineterminal qrcodes.
  private maxAgeOnlineBarcodeInHours = null;

  private checkInYardDisabled = false;

  constructor(
  ) {
    super();
    this.configurationService = WizardServiceLocator.injector.get(AppClientConfigurationService);
    this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === TerminalContextConstants.registrationCode
      && contextChange.value != null && contextChange.value.replace(/\s+/g, '').length > 0) {
      this.onRegistrationCode();
    } else if (contextChange.key === 'barcodeScanned') {
      this.onBarcodeScanned(contextChange.value);
    }
  }

  onRegisterToDashboardContext() {
    const qrCodeScanner = this.configurationService.getDeviceParameter('qrcode-scanner');
    console.log('Barcode.onRegister', qrCodeScanner);
    if (qrCodeScanner?.value === 'webcam') {
      this.dashboardContext.setContextValue('qrCodeScannerType', qrCodeScanner.value);
    }

    const dashboardConfiguration = this.wizardComponent.currentStep.dashboardConfiguration;
    if (dashboardConfiguration != null) {
      if (dashboardConfiguration.maxAgeOnlineBarcodeInHours != null) {
        this.maxAgeOnlineBarcodeInHours = dashboardConfiguration.maxAgeOnlineBarcodeInHours * 60 * 60 * 1000;
      }
      if (dashboardConfiguration.allowUnknownOnlineTerminalRegistrationCodes != null) {
        this.allowUnknownOnlineTerminalRegistrationCodes = dashboardConfiguration.allowUnknownOnlineTerminalRegistrationCodes === true;
      }
      if (dashboardConfiguration?.barcodeMapping != null) {
        this.barcodeMappings = dashboardConfiguration?.barcodeMapping;
      }
      if (dashboardConfiguration?.nextProcessStepRegistrationCode != null) {
        this.nextProcessStepRegistrationCode = dashboardConfiguration?.nextProcessStepRegistrationCode;
      }
      if (dashboardConfiguration?.checkInYardDisabled != null) {
        this.checkInYardDisabled = dashboardConfiguration?.checkInYardDisabled;
      }
    }
  }

  onRegistrationCode() {


    const appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);


    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
    return appServerAPI.execute(`/terminal/registration/visitor/code`, {
      code: this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode)
    }).toPromise().then((response: TerminalVisitorRegistration) => {
      this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
      this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
      if (response.status !== ResponseStatus.FAILED) {

        const registration = new TerminalVisitorRegistration(response);

        this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
        this.dashboardContext.setContextValue(TerminalContextConstants.lastname, registration.name);
        this.dashboardContext.setContextValue(TerminalContextConstants.firstname, registration.firstname);
        this.dashboardContext.setContextValue(TerminalContextConstants.company, registration.company);
        this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
        this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
        this.dashboardContext.setContextValue(TerminalContextConstants.reasonForVisit, registration.reason);
        this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, registration.visitedPerson);
        this.dashboardContext.setContextValue('needsAreaAccess', registration.needsAreaAccess);
        this.dashboardContext.setContextValue('entranceBarrierSecuredAreaNeeded', registration.needsAreaAccess);
        this.dashboardContext.setContextValue('instructionsDone', registration.instructionsDone);
        this.dashboardContext.setContextValue('visitorType', registration.visitorType);

        if (!this.checkInYardDisabled && registration.inYard) {
          const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
          logContainer.addLog('Valid code detected. Visitor in yard. Start leave process');
          this.wizardComponent.handoverToFlow('registration-terminal-visitor-leave');
        } else {
          const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
          logContainer.addLog('Valid code detected. New visitor.');
          if (registration.instructionsDone) {
            this.forwardToNextProcessStep('tmc-visit://registration/' + this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode));
          } else {
            this.forwardToNextProcessStep(null);
          }
        }

      } else {
        this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
      }
    }, error => {
    });
  }

  onBarcodeScanned(value: string) {

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);

    if (value != null && value.startsWith('tmc-visit://visitor')) {
      this.validateScannedVisitorCode(value);
    } else if (value != null && value.startsWith('tmc-visit://registration')) {
      this.validateScannedRegistrationCode(value);
    } else {
      console.warn('invalid QRCode scanned: No handler registered', value);
    }
  }

  private async validateScannedRegistrationCode(qrCodeContent: string) {
    const url = new URL(qrCodeContent);
    const registrationDate = Number(url.searchParams.get('registrationDate'));

    if (this.maxAgeOnlineBarcodeInHours != null && registrationDate + this.maxAgeOnlineBarcodeInHours < Date.now()) {
      const validationMessages = new Array<ValidationMessage>();
      validationMessages.push(ValidationMessage.createWithData(ValidationMessageType.ERROR, 'tmc-yard.widgets.registration-terminal.visitor-scan-registration-qrcode.error.invalid-qrcode'));
      this.dashboardContext.setContextValue('validationMessages', validationMessages);
      this.dashboardContext.setContextValue('responseMessages', validationMessages);
      return false;
    } else {
      const registrationCode = url.searchParams.get('registrationCode');

      if (registrationCode != null && registrationCode.trim().length > 0) {
        // Try to load visit
        const response = await this.loadVisitByRegistrationCode(registrationCode);
        this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
        if (response.status !== ResponseStatus.FAILED) {
          this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, response.registrationId);

          const registration = new TerminalVisitorRegistration(response);

          this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
          this.dashboardContext.setContextValue(TerminalContextConstants.lastname, registration.name);
          this.dashboardContext.setContextValue(TerminalContextConstants.firstname, registration.firstname);
          this.dashboardContext.setContextValue(TerminalContextConstants.company, registration.company);
          this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
          this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
          this.dashboardContext.setContextValue(TerminalContextConstants.reasonForVisit, registration.reason);
          this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, registration.visitedPerson);
          this.dashboardContext.setContextValue('needsAreaAccess', registration.needsAreaAccess);
          this.dashboardContext.setContextValue('entranceBarrierSecuredAreaNeeded', registration.needsAreaAccess);
          this.dashboardContext.setContextValue('instructionsDone', registration.instructionsDone);
          this.dashboardContext.setContextValue('visitorType', registration.visitorType);
          this.dashboardContext.setContextValue('inviterId', registration.inviterId);

          if (!this.checkInYardDisabled && registration.inYard) {
            const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
            logContainer.addLog('Valid code detected. Visitor in yard. Start leave process');
            this.wizardComponent.handoverToFlow('registration-terminal-visitor-leave');
          } else {
            const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
            logContainer.addLog('Valid code detected. New visitor.');
            if (registration.instructionsDone) {
              this.forwardToNextProcessStep('tmc-visit://registration/' + this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode));
            } else {
              this.forwardToNextProcessStep(null);
            }
            return;
          }
        } else if (this.allowUnknownOnlineTerminalRegistrationCodes === false) {
          const lastname = url.searchParams.get('lastname');
          const firstname = url.searchParams.get('firstname');
          const company = url.searchParams.get('company');
          const numberPlate = url.searchParams.get('numberPlate');
          const visitedPerson = url.searchParams.get('visitedPerson');
          const needsAreaAccess = url.searchParams.get('needsAreaAccess');
          const visitorType = url.searchParams.get('visitorType');
          const inviterId = url.searchParams.get('inviterId');

          // Werte aus Onlinebarcode vorbelegen
          this.dashboardContext.setContextValue(TerminalContextConstants.lastname, lastname != null ? lastname : null);
          this.dashboardContext.setContextValue(TerminalContextConstants.firstname, firstname != null ? firstname : null);
          this.dashboardContext.setContextValue(TerminalContextConstants.company, company != null ? company : null);
          this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, numberPlate != null ? numberPlate : null);
          this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, visitedPerson != null ? visitedPerson : null);
          this.dashboardContext.setContextValue('needsAreaAccess', needsAreaAccess != null && needsAreaAccess === 'true');
          this.dashboardContext.setContextValue('entranceBarrierSecuredAreaNeeded', needsAreaAccess != null && needsAreaAccess === 'true');
          this.dashboardContext.setContextValue('visitorType', visitorType);
          this.dashboardContext.setContextValue('inviterId', inviterId);

          const validationMessages = new Array<ValidationMessage>();
          for (const responseMessage of response.responseMessages) {
            validationMessages.push(ValidationMessage.createWithData(ValidationMessageType.ERROR, responseMessage.dictionaryKey));
          }
          this.dashboardContext.setContextValue('validationMessages', validationMessages);
          this.dashboardContext.setContextValue('responseMessages', response.responseMessages);
          return false;
        }

      }

      this.dashboardContext.setContextValue('registrationCode', registrationCode);
      this.forwardToNextProcessStep(qrCodeContent);
    }
  }

  private async loadVisitByRegistrationCode(registrationCode: string) {
    const barcodeScan = new BarcodeScan({ value: registrationCode });
    return await this.appServerAPI.execute<TerminalVisitorRegistrationResult>('/terminal/registration/visitor/barcode', barcodeScan).toPromise();
  }

  private async validateScannedVisitorCode(value: string) {
    const appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);

    const registrationCode = value.replace('tmc-visit://visitor/', '');

    const response = await this.loadVisitByRegistrationCode(registrationCode);

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
    this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
    if (response.status !== ResponseStatus.FAILED) {

      const registration = new TerminalVisitorRegistration(response);

      this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
      this.dashboardContext.setContextValue(TerminalContextConstants.lastname, registration.name);
      this.dashboardContext.setContextValue(TerminalContextConstants.firstname, registration.firstname);
      this.dashboardContext.setContextValue(TerminalContextConstants.company, registration.company);
      this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
      this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
      this.dashboardContext.setContextValue(TerminalContextConstants.reasonForVisit, registration.reason);
      this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, registration.visitedPerson);
      this.dashboardContext.setContextValue('needsAreaAccess', registration.needsAreaAccess);
      this.dashboardContext.setContextValue('visitorType', registration.visitorType);
      this.dashboardContext.setContextValue('instructionsDone', registration.instructionsDone);
      this.dashboardContext.setContextValue('inviterId', registration.inviterId);

      if (!this.checkInYardDisabled && registration.inYard) {
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('Valid code detected. Visitor in yard. Start leave process');
        this.wizardComponent.handoverToFlow('registration-terminal-visitor-leave');
      } else {
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('Valid code detected. New visitor.');
        if (registration.instructionsDone) {
          this.forwardToNextProcessStep('tmc-visit://registration/' + registrationCode);
        } else {
          this.forwardToNextProcessStep(value);
        }
      }

    } else {
      this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
    }

  }

  private forwardToNextProcessStep(barcode: string) {
    console.log(barcode);
    if (barcode === null) {
      this.wizardComponent.next(this.nextProcessStepRegistrationCode);
    } else {
      const config = this.barcodeMappings;
      for (const key of Object.keys(config)) {
        console.log('find by key', key, config[key]);
        if (('' + barcode).startsWith(key)) {
          this.wizardComponent.next(config[key]);
          return;
        }
      }
      const msg = ValidationMessage.createWithData(ValidationMessageType.ERROR, 'tmc-yard.widgets.registration-terminal.barcode-scan.barcode-not-processable');
      this.dashboardContext.setContextValue('validationMessage', msg);
    }
  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('register with code started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {
    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    const showCreateNewRegistrationButton = this.wizardComponent.currentStep.dashboardConfiguration?.showCreateNewRegistrationButton;
    if (showCreateNewRegistrationButton === true) {
      this.dashboardContext.setContextValue('newRegistrationEnabled', true);
      const newRegistrationControl = new StepControl();
      newRegistrationControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.button.alternative';
      newRegistrationControl.type = StepControlType.BUTTON_STROKED;
      newRegistrationControl.iconAfterCss = 'fa-thin fa-angle-right';
      newRegistrationControl.controlAction = () => {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.next('transport-registration-masterdata');
      };
      controls.push(newRegistrationControl);
    } else {
      this.dashboardContext.setContextValue('newRegistrationEnabled', false);
    }
    this.dashboardContext.setContextValue('qrCodeScanEnabled', this.wizardComponent.currentStep.dashboardConfiguration?.qrCodeScanEnabled == true);

    this.dashboardContext.setContextValue('registrationCodeMinLength', this.wizardComponent.currentStep.dashboardConfiguration?.registrationCodeMinLength);
    this.dashboardContext.setContextValue('registrationCodeMaxLength', this.wizardComponent.currentStep.dashboardConfiguration?.registrationCodeMaxLength);

    return controls;

  }
}
